'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = About;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function About() {
  return _react2.default.createElement(
    _caligramReact.Page,
    { title: '\xC0 propos' },
    _react2.default.createElement(
      'p',
      null,
      'Caligram est un calendrier incroyable.'
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/About.js
// module id = 1147
// module chunks = 0